<template>
    <section>
        <div class="filters">
            <el-row :gutter="10" class="w-100">
                <el-col :xs="24" :sm="12" :md="8" :lg="4" :xl="4">
                    <el-input v-model="query.keyword" size="small" clearable class="mt-1 w-100"
                              placeholder="Nhập mã, tên, số điện thoại"></el-input>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="4" :xl="4">
                    <el-select v-model="query.department_id" size="small" class="mt-1 w-100" clearable filterable
                               placeholder="Lọc Team">
                        <el-option
                            v-for="item in department"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="4" :xl="4">
                    <el-select v-model="query.account_type_id" size="small" placeholder="Chọn chức vụ" clearable  class="mt-1 w-100">
                        <el-option v-for="item in filteredPositions" :key="item.id" :label="item.name" :value="item.id" />
                    </el-select>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="4" :xl="4">
                    <el-select v-model="query.level" clearable placeholder="Level" size="small" class="mt-1 w-100">
                        <el-option
                            v-for="item in levels"
                            :key="item.id"
                            :label="item.level"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="4" :xl="4">
                    <el-select v-model="query.year" placeholder="Lọc năm" size="small" class="mt-1 w-100">
                        <el-option v-for="y in years" :key="y" :label="'Năm ' + y" :value="y" />
                    </el-select>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="4" :xl="4">
                    <el-select v-model="query.quarter" placeholder="Lọc quý" size="small" class="mt-1 w-100">
                        <el-option v-for="q in [1,2,3,4]" :key="q" :label="'Quý ' + convertToRoman(q)" :value="q" />
                    </el-select>
                </el-col>
            </el-row>
        </div>

        <div class="section-card">
            <AdminReviewTable :items="items" :loading="loading"/>
        </div>

        <div class="pager">
            <el-pagination
                background
                layout="prev, pager, next, total"
                :page-size="pageSize"
                :current-page.sync="page"
                :total="total"
            />
        </div>
    </section>
</template>

<script>
import {GET_DEPARTMENT_BY_DEPARTMENT_HEAD} from "@/core/services/store/profile.module";
import {
    GET_DOMAIN_REVIEW_LIST , GET_LIST_LEVEL
} from "@/core/services/store/approve-team-level/approveTeamLevel.module";

import AdminReviewTable from "./table/AdminReviewTable.vue";
import {mapGetters} from "vuex";
export default {
    name: 'AdminReviewTab',
    components: {
        AdminReviewTable,
    },
    data() {
        const now = new Date().getFullYear();
        return {
            query: { keyword: '', department_id: null, account_type_id: null, level: null, year: now, quarter: 1 },
            years: [],
            items: [],
            department: [],
            levels: [],
            loading: false,
            page: 1,
            pageSize: 10,
            total: 20,
            domainCriteriaDialog: false,
            _debounceTimer: null,
            _skipQueryWatch: false,
            statusMap: {
                1: { label: 'Duyệt', color: '#7ED957', type: '' },
                2: { label: 'Chờ duyệt', color: '', type: 'info' },
                3: { label: 'Không duyệt', color: '', type: 'danger' },
            },
            positions: [
                {id: 14, name: 'Nhân viên'},
                {id: 32, name: 'Trưởng bộ phận'},
                {id: 16, name: 'Trưởng phòng'},
                {id: 34, name: 'Trưởng nhóm'},
            ],

            accountTypeMap: {
                14: [14], // Nhân viên
                32: [14,32,34], //Trưởng bộ phận
                16: [14,32,16,34], // Trưởng phòng
                34: [14], // Trưởng nhóm
            },
        };
    },
    mounted() {
        this.getCurrentQuarterAndYear();
        this.getDepartmentByUserId(this.currentUser.id);
        this.getListLevel();
        this.initFromRoute();
    },
    watch: {
        // Khi user thay đổi filter -> reset page, update URL và reload
        query: {
            deep: true,
            handler() {
                if (this._skipQueryWatch) return;
                if (this._debounceTimer) clearTimeout(this._debounceTimer);
                this.page = 1;
                this._debounceTimer = setTimeout(() => {
                    this.updateRoute();
                    this.reload();
                }, 0);
            },
        },
        // Thay đổi trang hiện tại
        page() {
            if (this._skipQueryWatch) return;
            this.updateRoute();
            this.reload();
        },
        // Thay đổi kích thước trang -> quay về trang 1
        pageSize() {
            if (this._skipQueryWatch) return;
            this.page = 1;
            this.updateRoute();
            this.reload();
        },
        // Khi URL thay đổi (back/forward/tab switch) -> update filter
        '$route.query': {
            handler(newQuery) {
                if (newQuery.tab !== 'admin') return;
                this.applyRouteToQuery(newQuery);
                // Trigger reload when switching to admin tab to avoid stale/empty flicker
                this.reload();
            },
        },
    },
    methods: {
        convertToRoman(num) {
            const romanNumerals = { 1: 'I', 2: 'II', 3: 'III', 4: 'IV' };
            return romanNumerals[num] || num;
        },
        getCurrentQuarterAndYear() {
            const now = new Date();
            const y = now.getFullYear();
            const s = 2025;
            const currentQuarter = (now.getMonth() / 3 | 0) + 1;
            const rq = this.$route?.query || {};
            if (rq.tab !== 'admin' || !rq.quarter) {
                this.query.quarter = currentQuarter;
            }
            this.query.year = (this.query.year && this.query.year >= s && this.query.year <= y) ? this.query.year : y;
            this.years = Array.from({ length: Math.max(1, y - s + 1) }, (_, i) => s + i);
        },
        clearData() {
            this.items = [];
            this.total = 0;
        },
        reload() {
            this.loading = true;
            this.clearData();
            const payload = {
                page: this.page,
                pageSize: this.pageSize,
                keyword: this.query.keyword,
                department_id: this.query.department_id,
                account_type_id: this.query.account_type_id,
                current_level: this.query.level,
                year: this.query.year,
                quarter: this.query.quarter,
                level_type: 2,
            };
            this.$store.dispatch(GET_DOMAIN_REVIEW_LIST, payload).then((res) => {
                this.total = res.data.total;
                this.pageSize = res.data.per_page;
                this.page = res.data.current_page;
                this.items = res && res.data && res.data.data ? res.data.data : { items: [], total: 0 };
            }).finally(() => {
                this.loading = false;
            });
        },

        getDepartmentByUserId(user_id) {
            this.$store.dispatch(GET_DEPARTMENT_BY_DEPARTMENT_HEAD, {
                user_id
            }).then((res) => {
                this.department = res.data;
                console.log('this.department', this.department)
            }).catch(() => {

            })
        },

        getListLevel() {
            this.$store.dispatch(GET_LIST_LEVEL, {
                type: 2
            }).then((res) => {
                this.levels = res.data;
            }).catch(() => {

            })
        },

        // Khởi tạo từ URL (chỉ gọi 1 lần khi mount)
        initFromRoute() {
            const q = this.$route.query;
            if (q.tab === 'admin') {
                this.applyRouteToQuery(q);
            } else {
                this.updateRoute();
            }
            this.reload();
        },
        // Áp dụng URL params vào state (Route -> State)
        applyRouteToQuery(routeQuery) {
            this._skipQueryWatch = true;
            const toInt = v => (v === undefined || v === null || v === '' ? null : parseInt(v, 10));
            this.query.keyword = routeQuery.keyword || '';
            this.query.department_id = toInt(routeQuery.department_id);
            this.query.account_type_id = toInt(routeQuery.account_type_id);
            this.query.level = toInt(routeQuery.level);
            this.query.year = toInt(routeQuery.year) || this.query.year;
            this.query.quarter = toInt(routeQuery.quarter) || this.query.quarter;
            this.page = toInt(routeQuery.page) || 1;
            this.pageSize = toInt(routeQuery.pageSize) || 10;
            this.$nextTick(() => { this._skipQueryWatch = false; });
        },
        // Cập nhật URL từ state (State -> Route)
        updateRoute() {
            const newQuery = {
                keyword: this.query.keyword || undefined,
                department_id: this.query.department_id || undefined,
                account_type_id: this.query.account_type_id || undefined,
                level: this.query.level || undefined,
                year: this.query.year || undefined,
                quarter: this.query.quarter || undefined,
                page: this.page || undefined,
                pageSize: this.pageSize || undefined,
                tab: 'admin'
            };
            const currentQuery = this.$route.query;
            if (JSON.stringify(newQuery) !== JSON.stringify(currentQuery)) {
                this.$router.replace({ query: newQuery }).catch(() => {});
            }
        },
    },

    computed: {
        ...mapGetters(['currentUser']),
        filteredPositions() {
            let accountTypeIid = this.currentUser.account_type?.id ?? 0;
            if (!accountTypeIid) return this.positions;
            let ids = this.accountTypeMap[accountTypeIid] || [];
            return this.positions.filter(p => ids.includes(p.id));
        }
    },
};
</script>

<style lang="scss" scoped>
.filters { margin-bottom: 12px; display: flex; align-items: center; flex-wrap: wrap; }
.filters .el-col { margin-bottom: 8px; }

::v-deep {
    .domain-table {
        .el-table__header th,
        .el-table__body td,
        .el-table__header th .cell,
        .el-table__body td .cell {
            white-space: normal !important;
            word-break: break-word !important;
            overflow: visible !important;
            max-width: none !important;
            height: auto !important;
            text-align: center !important;
        }

        .el-table__header th {
            background: #4d1eab !important;
            color: #fff !important;
            border-color: #4d1eab !important;
            line-height: 1.4 !important;
            padding: 16px 8px !important;
            height: 80px !important;
        }

        .el-table__body td {
            line-height: 1.3 !important;
            padding: 8px 4px !important;
            height: auto !important;
        }
    }
}

.trend { font-weight: 600; }
.trend.up { color: #16a34a; }
.trend.hold { color: #f59e0b; }
.trend.down { color: #ef4444; }

.btn-approve-level { border-radius: 6px; color: #FFFFFF; width: 100% }

.pager {
    display: flex;
    justify-content: center;
    margin-top: 20px;
}

.section-card {
    background: white;
    border-radius: 12px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    margin-bottom: 24px;
    overflow: hidden;
}
</style>


